import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default function ScheduleFields({ form, set }) {
  const days = form.work_days || [];
  const toggle = (i) => set("work_days", days.includes(i) ? days.filter((d) => d !== i) : [...days, i].sort());
  return (
    <div className="sm:col-span-2 rounded-xl border border-slate-200 bg-slate-50/60 p-4 space-y-3" data-testid="schedule-fields">
      <div className="text-sm font-semibold text-slate-800">Online booking schedule</div>
      <div className="flex flex-wrap gap-2">
        {DAYS.map((d, i) => (
          <button type="button" key={d} onClick={() => toggle(i)} data-testid={`workday-${d.toLowerCase()}`}
            className={`h-9 px-3 rounded-full text-sm font-medium border transition-colors ${days.includes(i) ? "bg-teal-600 text-white border-teal-600" : "bg-white text-slate-600 border-slate-200 hover:border-teal-400"}`}>{d}</button>
        ))}
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="space-y-1"><Label className="text-xs">Start</Label><Input data-testid="schedule-start-input" type="time" value={form.start_time || "10:00"} onChange={(e) => set("start_time", e.target.value)} /></div>
        <div className="space-y-1"><Label className="text-xs">End</Label><Input data-testid="schedule-end-input" type="time" value={form.end_time || "17:00"} onChange={(e) => set("end_time", e.target.value)} /></div>
        <div className="space-y-1"><Label className="text-xs">Slot (min)</Label><Input data-testid="schedule-slot-input" type="number" min="5" max="240" step="5" value={form.slot_minutes ?? 30} onChange={(e) => set("slot_minutes", e.target.value)} /></div>
      </div>
      <p className="text-xs text-slate-500">Patients can only pick these days and times online. One patient per slot.</p>
    </div>
  );
}
